export const LOGIN = '/login';
export const LOGIN_EXPIRED = '/login-expired';
export const CHANGE_EXPIRED_PASSWORD = '/change-expired-password';
export const SET_PASSWORD = '/reset-password';
export const PASSWORD_RESET = '/forgot-password';
export const BLOCKED_USER = '/blocked-account';
export const DASHBOARD = '/dashboard';
export const CHICKEN_DASHBOARD = `${DASHBOARD}/chicken`;
export const CHICKEN_CHARTS_DASHBOARD = `${DASHBOARD}/charts`;
export const CHICKEN_PERFORMANCE = '/performance/chicken';
export const FRAHA_DASHBOARD = '/dashboard/potato';
export const POTATO_EVENTS = '/events/potato';
export const CHICKEN_EVENTS = '/events/chicken';
export const ANALYTIC_EVENTS = '/events/analytics';
export const HOT_HOLDING = '/timers-cycle-history/hot-holding';
export const MERCO_HOT_HOLDING = '/timers-cycle-history/merco-hot-holding';
export const TIMERS_ANALYTICS = '/timers-cycle-history/analytics';
export const ENTRY_CHUTES = '/entry-chutes';
export const BASKET_EVENTS = '/basket-events';
export const FRYER_EVENTS = '/timers-cycle-history/fryer';
export const DUMP_PAN_EVENTS = '/timers-cycle-history/dump-pan';
export const FRY_CHUTES_EVENTS = '/timers-cycle-history/fry-chutes';
export const PRQ_EVENTS = '/timers-cycle-history/prq';
export const BREADING_EVENTS = '/timers-cycle-history/breading';
export const CONVEYOR_EVENTS = '/timers-cycle-history/conveyor';
export const CATERING_EVENTS = '/timers-cycle-history/scheduled-production';
export const ENTREE_CHUTES_EVENTS = '/timers-cycle-history/entree-chutes';
export const PRS_EVENTS = '/timers-cycle-history/prs';
export const UNUSUAL_EVENT = '/unusual/event';
export const UNUSUAL_DP_REMAINING = '/unusual/dp-remaining';
export const UNUSUAL_WRONG_MARKER = '/unusual/wrong-marker';
export const UNUSUAL_EMPTY_PAN = '/unusual/empty-pan';
export const UNUSUAL_IDENTICAL = '/unusual/identical-markers';
export const UNUSUAL_RECORDINGS = '/unusual/recordings';
export const DEVICES_PC = '/devices/pc';
export const DEVICES_TABLETS = '/devices/tablets';
export const TABLET_LOGS = '/devices/tablets/:uuid/logs';
export const TABLET_LOG = '/devices/tablets/:uuid/logs/:logUuid';
export const TABLET_SESSIONS = '/devices/tablets/:uuid/sessions';
export const TABLET_SETTINGS = '/devices/tablets/:uuid/settings';
export const RESTAURANTS = '/restaurants';
export const RESTAURANTS_DEVICES_PC = '/restaurants/:uuid/devices/pc';
export const RESTAURANTS_DEVICES_TABLETS = '/restaurants/:uuid/devices/tablets';
export const AUDIT_LOG = '/administration/audit-log';
export const POLICIES = '/administration/policies';
export const ROLES = '/administration/roles';
export const USERS = '/administration/users';
export const USER_SESSIONS = '/administration/users/:uuid/sessions';
export const KITCHEN_PLAYER = '/kitchen-player/player';
export const KITCHEN_PLAYER_RECORDINGS = '/kitchen-player/recordings';
export const KITCHEN_PLAYER_CLIPS = '/kitchen-player/clips';
export const SETTINGS_CHICKEN_MATERIALS = '/settings/chicken/materials';
export const SETTINGS_CHICKEN_GRILLED_MATERIALS = '/settings/chicken/grilled-materials';
export const SETTINGS_CHICKEN_CONTAINERS = '/settings/chicken/containers';
export const SETTINGS_CHICKEN_MERCO_TRAYS = '/settings/chicken/mercoTrays';
export const SETTINGS_CHICKEN_PACKAGES = '/settings/chicken/packages';
export const SETTINGS_POTATO_MATERIALS = '/settings/potato/materials';
export const SETTINGS_POTATO_PACKAGES = '/settings/potato/packages';
export const SUPPORT_HISTORY = '/support-history';
export const PLUG_TAB = '/plug-play/plug';
export const ARUCO_VALIDATION = '/plug-play/aruco';
export const CHUTES_CONFIG = '/plug-play/entree-chutes';
export const CHUTES_CONFIG_SETUP = '/plug-play/entree-chutes-setup';
export const AUTHENTIFICATION_LOG = '/user-settings/authentification-log';
export const ACTIVE_SESSIONS = '/user-settings/active-sessions';
export const USER_SECURITY = '/user-settings/security';
export const MONITORING_GRAPHICS = '/monitoring/graphics';
export const MONITORING_PCS_CHARTS = '/monitoring/pcs-charts';
export const MONITORING_ALERTS = '/monitoring/alerts';
export const CAMERAS_MANAGEMENT_VIEW = '/cameras/view';
export const CAMERAS_MANAGEMENT_SETTINGS = '/cameras/settings';
export const CAMERAS_MANAGEMENT_RECORDINGS = '/cameras/recordings';
export const CAMERAS_MANAGEMENT_CLIPS = '/cameras/clips';
export const REPORTS = '/reports';
export const MULTI_FACTOR_AUTH = '/multi-step-auth';
export const SERVER_MANAGEMENT = '/monitoring/server-management';
export const STOCK_OUT_REPORTS = '/stock-out-reports/chicken';
export const PRODUCTION_QUEUE = '/pcs/monitor'; // CFAPCS-2863 - rename to MONITOR
export const CATERING_INVENTORY = '/pcs/scheduled-production';
export const FRYER_MANAGER = '/pcs/fryer-manager';
export const ADJUSTMENT = '/pcs/adjustment';
export const ADJUSTMENT_VERSIONS = '/pcs/adjustment/versions';
export const ADJUSTMENT_VERSION = '/pcs/adjustment/versions/:uuid';
export const ADJUSTMENT_VERSION_COMPARISON = '/pcs/adjustment/compare-versions';
export const RECOMMENDATIONS = '/pcs/recommendations';
export const WASTE = '/waste';
export const TRAINING = '/training';
export const TRAINING_DETAILS = '/training/:uuid';
export const ASSISTANT_ACTIVITY = '/assistant/activity';
export const ASSISTANT_HISTORY = '/assistant/history';
export const RESOURCES = '/pcs-training';
export const ALERTS = '/alerts';
export const ALERT_DEFINITIONS = '/alerts/definitions';
export const SUPPORT_GROUPS = '/alerts/support-groups';
export const SUPPORT_USERS = '/alerts/users';
